var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GET_USER_DROP_EVENT_LANDING_SHORT_URL } from 'root/src/shared/descriptions/endpoints/endpointIds';
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest';
export const getUserDropEventLandingShortUrl = (dropEventId) => (_, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { body } = yield invokeApiRequest(GET_USER_DROP_EVENT_LANDING_SHORT_URL, { dropEventId }, state);
    return body;
});
